export default "__VITE_PUBLIC_ASSET__b87cdf1f__"